export default __webpack_public_path__ + "static/Gatsby-aaf3541c9f069dd89098cc794accc289.png";